import React, { useEffect, useState, useRef } from "react"
import "./EditInstitution.scss"
import { useLocation, useNavigate } from "react-router-dom"
import UniversityApi from "Api/UniversityApi"
import * as Yup from "yup"
import { Button, Card, CardBody, Col, Row, Spinner } from "reactstrap"
import { InputNumber } from "primereact/inputnumber"
import { InputText } from "primereact/inputtext"
import { Dropdown } from "primereact/dropdown"
import { Calendar } from "primereact/calendar"
import CustomBreadCrumb from "utils/CustomBreadCrumb/CustomBreadCrumb"
import Country from "utils/Data/Country"
import InstituteApi from "Api/InstituteApi"
import { set } from "lodash"
import { Toast } from "primereact/toast"
import S3UploadApi from "Api/s3Upload"
import { Avatar } from "primereact/avatar"
import { formatDistanceToNow } from "date-fns"

const EditInstitution = () => {
  document.title = "Edit Institution"

  const accessToken = localStorage.getItem("accessToken")
  const navigate = useNavigate("")
  const location = useLocation("")
  const institutionData = location?.state
  const userData = JSON.parse(localStorage.getItem("userData"))
  const [errors, setErrors] = useState({})

  const [dialCode, phoneNumber] = institutionData?.phone
    ? institutionData?.phone?.split("-")
    : [null, null]
  const [universityData, setUniversityData] = useState([])
  const [logoFile, setLogoFile] = useState(null)
  const [logoUrl, setLogoUrl] = useState(institutionData?.logo.url || "")
  const [isUploading, setIsUploading] = useState(false)
  const [brochureFile, setBrochureFile] = useState(null)
  const [brochureUrl, setBrochureUrl] = useState(
    institutionData?.brochure.url || "",
  )
  const toast = useRef(null)
  const [bannerFile, setBannerFile] = useState(null)
  const [bannerUrl, setBannerUrl] = useState(
    
    institutionData?.bannerImage.url || "",
  
  )
  const [isUploadingBanner, setIsUploadingBanner] = useState(false)
  const [galleryFiles, setGalleryFiles] = useState([])
  const [galleryUrls, setGalleryUrls] = useState(institutionData?.gallery || [])
  const [isUploadingGallery, setIsUploadingGallery] = useState(false)

  // Add new state for gallery alt texts
  const [galleryAltTexts, setGalleryAltTexts] = useState(
    institutionData?.gallery?.map(img => img.alt || "") || [],
  )

  const refinedInstitutionData = {
    ...institutionData,
    category: {
      name: institutionData?.category?.charAt(0)?.toUpperCase() + institutionData?.category?.slice(1),
      code: institutionData?.category?.toLowerCase()
    },
    type: {
      name:
        institutionData?.type?.charAt(0)?.toUpperCase() +
        institutionData?.type?.slice(1),
      code:
        institutionData?.type?.charAt(0)?.toUpperCase() +
        institutionData?.type?.slice(1),
    },
    country: {
      name: institutionData?.country,
      code: institutionData?.country,
    },
    ugcApproval: {
      name: institutionData?.ugcApproval ? "Yes" : "No",
      code: institutionData?.ugcApproval ? "Yes" : "No",
    },
    aiuAffiliation: {
      name: institutionData?.aiuAffiliation ? "Yes" : "No",
      code: institutionData?.aiuAffiliation ? "Yes" : "No",
    },
    verifiedStatus: {
      name: institutionData?.verifiedStatus?.charAt(0)?.toUpperCase() + institutionData?.verifiedStatus?.slice(1) || "Pending",
      code: institutionData?.verifiedStatus?.toLowerCase() || "pending",
    },
    topPick: {
      name: institutionData?.topPick ? "Yes" : "No",
      code: institutionData?.topPick ? "Yes" : "No",
    },
    verifiedReason: institutionData?.verifiedReason
      ? institutionData?.verifiedReason
      : "",
    cutoffs: Array.isArray(institutionData?.cutoffs)
      ? institutionData.cutoffs
      : [],
    reviews: Array.isArray(institutionData?.reviews)
      ? institutionData.reviews
      : [],
    qsRanking: institutionData?.qsRanking || null,
    beddedHospital: institutionData?.beddedHospital || null,
    yearlyIntake: institutionData?.yearlyIntake || null,
    departments: Array.isArray(institutionData?.departments)
      ? institutionData.departments
      : [],
    logo: {
      url: institutionData?.logo || "",
      alt: institutionData?.logoAlt || "Institution Logo",
    },
    bannerImage: {
      url: institutionData?.bannerImage || "",
      alt: institutionData?.bannerAlt || "Institution Banner",
    },
    gallery: Array.isArray(institutionData?.gallery)
      ? institutionData.gallery.map(img => ({
          url: img.url || img,
          alt: img.alt || "Institution Gallery Image",
        }))
      : [],
    brochure: {
      url: institutionData?.brochure.url || "",
      alt: institutionData?.brochure.alt || "Institution Brochure",
    },
    pixwikShow: {
      name: institutionData?.pixwikShow ? "Yes" : "No",
      code: institutionData?.pixwikShow ? "Yes" : "No",
    },
  }

  const [updatedInstitutionData, setUpdatedInstitutionData] = useState(
    refinedInstitutionData,
  )

  // Add this useEffect to ensure arrays are properly initialized
  useEffect(() => {
    if (!Array.isArray(updatedInstitutionData.cutoffs)) {
      setUpdatedInstitutionData(prev => ({ ...prev, cutoffs: [] }))
    }
    if (!Array.isArray(updatedInstitutionData.departments)) {
      setUpdatedInstitutionData(prev => ({ ...prev, departments: [] }))
    }
    if (!Array.isArray(updatedInstitutionData.reviews)) {
      setUpdatedInstitutionData(prev => ({ ...prev, reviews: [] }))
    }
    if (!Array.isArray(updatedInstitutionData.gallery)) {
      setUpdatedInstitutionData(prev => ({ ...prev, gallery: [] }))
    }
  }, [])

  const handleInstitutionDataChange = (name, value) => {
    setUpdatedInstitutionData(prevState => ({
      ...prevState,
      [name]: value,
    }))
    setErrors({ ...errors, [name]: "" })
  }

  const breadcrumbItems = [
    { label: "Home" },
    { label: "Institution" },
    { label: "Edit Institution" },
  ]

  const typeOptions = [
    { name: "Central", code: "Central" },
    { name: "State", code: "State" },
    { name: "Private", code: "Private" },
    { name: "Deemed", code: "Deemed" },
    { name: "Autonomous", code: "Autonomous" },
    { name: "Government", code: "Government" },
  ]
  const categoryOptions = [
    { name: "Medical", code: "medical" },
    { name: "Engineering", code: "engineering" },
    { name: "Arts & Science", code: "artsAndScience" },
    { name: "Agriculture", code: "agriculture" },
    { name: "Law", code: "law" },
    { name: "Management", code: "management" }
  ]

  const verficationOption = [
    { name: "Approved", code: "approved" },
    { name: "Rejected", code: "rejected" },
    { name: "Pending", code: "pending" },
  ]
  const approvalOptions = [
    { name: "Yes", code: "Yes" },
    { name: "No", code: "No" },
  ]

  const quotaOptions = [
    { name: "OC", code: "OC" },
    { name: "OBC", code: "OBC" },
    { name: "SC", code: "SC" },
    { name: "ST", code: "ST" },
  ]

  const getUniversityMenu = () => {
    const config = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }
    UniversityApi.getUniversityMenuList(config)
      .then(res => {
        setUniversityData(res.data.university)
      })
      .catch(err => {})
  }

  useEffect(() => {
    getUniversityMenu()
  }, [accessToken])

  const ValidateInstitution = Yup.object().shape({
    institutionName: Yup.string().required("Institution name is required"),
    displayName: Yup.string().required("Display name is required"),
    // category: Yup.string()
    //   .oneOf(
    //     [
    //       "medical",
    //       "engineering",
    //       "arts",
    //       "science",
    //       "commerce",
    //       "law",
    //       "management",
    //     ],
    //     "Invalid category",
    //   )
    //   .required("Category is required"),
    // yearEstablished: Yup.number()
    //   .typeError("Established year must be a valid number")
    //   .min(1800, "Year cannot be before 1800")
    //   .max(new Date().getFullYear(), "Year cannot be in the future")
    //   .required("Established year is required"),
    country: Yup.string().required("Country is required"),
    state: Yup.string().required("State is required"),
    city: Yup.string().required("City is required"),
    pinCode: Yup.string()
      .required("PinCode is required"),
    address: Yup.string().required("Address is required"),
    // email: Yup.string()
    //   .email("Invalid email format")
    //   .required("Email is required"),
    // officialWebsite: Yup.string().required("officialWebsite is required"),
    // nirfRanking: Yup.string().required("nirfRanking is required"),
    // indiaToday2023Ranking: Yup.string().required(
    //   "indiaToday2023Ranking is required",
    // ),
    // timesRanking2024: Yup.string().required("timesRanking2024 is required"),
    // campusSize: Yup.string().required("campusSize is required"),
    // noOfStudents: Yup.string().required("noOfStudents is required"),
    // noOfDepartments: Yup.string().required("noOfDepartments is required"),
    // noOfCourses: Yup.string().required("noOfCourses is required"),
    // totalFaculty: Yup.string().required("totalFaculty is required"),
    // ugcApproval: Yup.boolean()
    //   .oneOf([true, false], "Invalid UGC approval")
    //   .required("Choose UGC Approval"),
    // aiuAffiliation: Yup.boolean()
    //   .oneOf([true, false], "Invalid AIU Affiliation")
    //   .required("Choose AIU Affiliation"),
    highlights: Yup.string().required("highlights is required"),
    aboutContent: Yup.string().required("aboutContent is required"),
    // qsRanking: Yup.number()
    //   .typeError("QS Ranking must be a number")
    //   .nullable()
    //   .min(1, "QS Ranking must be greater than 0"),
    // beddedHospital: Yup.number()
    //   .typeError("Bedded Hospital must be a number")
    //   .nullable()
    //   .min(0, "Bedded Hospital cannot be negative"),
  })

  const [loading, setLoading] = useState(false)

  const handleLogoChange = e => {
    if (e.target.files && e.target.files[0]) {
      setLogoFile(e.target.files[0])
      setLogoUrl("")
    }
  }

  const uploadLogo = async () => {
    if (!logoFile) return null

    setIsUploading(true)
    try {
      // First delete the existing logo if it exists
      if (logoUrl) {
        await deleteImage(logoUrl)
      }

      const formData = new FormData()
      formData.append("image", logoFile)

      const response = await S3UploadApi.uploadImage(formData)
      const newLogoUrl = response.data.imageUrl

      setLogoUrl(newLogoUrl)
      handleInstitutionDataChange("logo", {
        url: newLogoUrl,
        alt: updatedInstitutionData.logo?.alt || "Institution Logo",
      })
      setLogoFile(null)
      setIsUploading(false)
      toast.current.show({
        severity: "success",
        summary: "Success",
        detail: "Logo uploaded successfully",
        life: 3000,
      })
      return newLogoUrl
    } catch (error) {
      console.error("Error uploading logo:", error)
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Error uploading logo",
        life: 3000,
      })
      setIsUploading(false)
      return null
    }
  }

  // Add handlers for banner
  const handleBannerChange = e => {
    if (e.target.files && e.target.files[0]) {
      setBannerFile(e.target.files[0])
      setBannerUrl("")
    }
  }

  const handleBannerDelete = async () => {
    if (bannerUrl) {
      const success = await deleteImage(bannerUrl)
      if (success) {
        setBannerUrl("")
        handleInstitutionDataChange("bannerImage", {
          url: "",
          alt: updatedInstitutionData.bannerImage?.alt || "Institution Banner",
        })
        const fileInput = document.getElementById("banner")
        if (fileInput) {
          fileInput.value = ""
        }
      }
    }
  }

  // Add handlers for gallery
  const handleGalleryChange = e => {
    if (e.target.files) {
      setGalleryFiles([...e.target.files])
    }
  }

  const removeGalleryImage = async indexToRemove => {
    const imageUrl = galleryUrls[indexToRemove]
    const success = await deleteImage(imageUrl)
    if (success) {
      const newGalleryUrls = galleryUrls.filter(
        (_, index) => index !== indexToRemove,
      )
      setGalleryUrls(newGalleryUrls)
      handleInstitutionDataChange(
        "gallery",
        newGalleryUrls.map(url => ({
          url,
          alt: galleryAltTexts[indexToRemove] || "",
        })),
      )
    }
  }

  const deleteImage = async imageUrl => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }

      await S3UploadApi.deleteImage({ fileUrl: imageUrl }, config)
      toast.current.show({
        severity: "success",
        summary: "Success",
        detail: "Image deleted successfully",
        life: 3000,
      })
      return true
    } catch (error) {
      console.error("Error deleting image:", error)
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Failed to delete image",
        life: 3000,
      })
      return false
    }
  }

  const uploadBanner = async () => {
    if (!bannerFile) return null

    setIsUploadingBanner(true)
    try {
      if (bannerUrl) {
        await deleteImage(bannerUrl)
      }

      const formData = new FormData()
      formData.append("image", bannerFile)

      const response = await S3UploadApi.uploadImage(formData)
      const newBannerUrl = response.data.imageUrl

      setBannerUrl(newBannerUrl)
      handleInstitutionDataChange("bannerImage", {
        url: newBannerUrl,
        alt: updatedInstitutionData.bannerImage?.alt || "Institution Banner",
      })
      setBannerFile(null)
      setIsUploadingBanner(false)
      toast.current.show({
        severity: "success",
        summary: "Success",
        detail: "Banner uploaded successfully",
        life: 3000,
      })
      return newBannerUrl
    } catch (error) {
      console.error("Error uploading banner:", error)
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Error uploading banner",
        life: 3000,
      })
      setIsUploadingBanner(false)
      return null
    }
  }

  const uploadGalleryImages = async () => {
    if (!galleryFiles.length) return []

    setIsUploadingGallery(true)
    try {
      const uploadPromises = galleryFiles.map(async file => {
        const formData = new FormData()
        formData.append("image", file)

        const response = await S3UploadApi.uploadImage(formData)
        return response.data.imageUrl
      })

      const newGalleryUrls = await Promise.all(uploadPromises)

      setGalleryUrls(prevUrls => [
        ...prevUrls,
        ...newGalleryUrls.map(url => ({
          url,
          alt: galleryAltTexts[prevUrls.length] || "",
        })),
      ])
      handleInstitutionDataChange("gallery", [
        ...galleryUrls,
        ...newGalleryUrls.map(url => ({
          url,
          alt: galleryAltTexts[galleryUrls.length] || "",
        })),
      ])
      setGalleryFiles([])
      setIsUploadingGallery(false)
      toast.current.show({
        severity: "success",
        summary: "Success",
        detail: "Gallery images uploaded successfully",
        life: 3000,
      })
      return newGalleryUrls
    } catch (error) {
      console.error("Error uploading gallery:", error)
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Error uploading gallery images",
        life: 3000,
      })
      setIsUploadingGallery(false)
      return []
    }
  }

  const handleLogoDelete = async () => {
    if (logoUrl) {
      const success = await deleteImage(logoUrl)
      if (success) {
        setLogoUrl("")
        handleInstitutionDataChange("logo", {
          url: "",
          alt: updatedInstitutionData.logo?.alt || "Institution Logo",
        })
        const fileInput = document.getElementById("logo")
        if (fileInput) {
          fileInput.value = ""
        }
      }
    }
  }

  const handleBrochureChange = e => {
    if (e.target.files && e.target.files[0]) {
      setBrochureFile(e.target.files[0])
      setBrochureUrl("")
    }
  }

  const uploadBrochure = async () => {
    if (!brochureFile) return null

    setIsUploading(true)
    try {
      if (brochureUrl) {
        await deleteImage(brochureUrl)
      }

      const formData = new FormData()
      formData.append("image", brochureFile)

      const response = await S3UploadApi.uploadImage(formData)
      const newBrochureUrl = response.data.imageUrl

      setBrochureUrl(newBrochureUrl)
      handleInstitutionDataChange("brochure", {
        url: newBrochureUrl
      })
      setBrochureFile(null)
      setIsUploading(false)
      toast.current.show({
        severity: "success",
        summary: "Success",
        detail: "Brochure uploaded successfully",
        life: 3000,
      })
      return newBrochureUrl
    } catch (error) {
      console.error("Error uploading brochure:", error)
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Error uploading brochure",
        life: 3000,
      })
      setIsUploading(false)
      return null
    }
  }

  const handleBrochureDelete = async () => {
    if (brochureUrl) {
      const success = await deleteImage(brochureUrl)
      if (success) {
        setBrochureUrl("")
        handleInstitutionDataChange("brochure", {
          url: ""
        })
        const fileInput = document.getElementById("brochure")
        if (fileInput) {
          fileInput.value = ""
        }
      }
    }
  }

  const handleGalleryAltTextChange = (index, value) => {
    const newAltTexts = [...galleryAltTexts]
    newAltTexts[index] = value
    setGalleryAltTexts(newAltTexts)

    const updatedGallery = galleryUrls.map((url, i) => ({
      url,
      alt: newAltTexts[i] || "",
    }))
    handleInstitutionDataChange("gallery", updatedGallery)
  }

  const updateUniversity = async () => {
    try {
      // Upload logo if needed
      if (logoFile && !logoUrl) {
        const uploadedUrl = await uploadLogo()
        if (!uploadedUrl) {
          toast.current.show({
            severity: "error",
            summary: "Error",
            detail:
              "Failed to upload logo. Please try uploading again before updating.",
            life: 3000,
          })
          return
        }
      }

      // Upload banner if needed
      if (bannerFile && !bannerUrl) {
        const uploadedBannerUrl = await uploadBanner()
        if (!uploadedBannerUrl) {
          toast.current.show({
            severity: "error",
            summary: "Error",
            detail:
              "Failed to upload banner. Please try uploading again before updating.",
            life: 3000,
          })
          return
        }
      }

      // Upload gallery images if needed
      if (galleryFiles.length > 0) {
        const uploadedGalleryUrls = await uploadGalleryImages()
        if (!uploadedGalleryUrls.length) {
          toast.current.show({
            severity: "error",
            summary: "Error",
            detail:
              "Failed to upload gallery images. Please try uploading again before updating.",
            life: 3000,
          })
          return
        }
      }

      handleInstitutionDataChange("logo", {
        url: logoUrl,
        alt: updatedInstitutionData.logo?.alt || "Institution Logo",
      })

      const { phoneCode, ...otherInstitutionData } = updatedInstitutionData

      setLoading(true)
      const payload = {
        ...otherInstitutionData,
        logo: {
          url: logoUrl,
          alt: updatedInstitutionData.logo?.alt || "Institution Logo",
        },
        bannerImage: {
          url: bannerUrl,
          alt: updatedInstitutionData.bannerImage?.alt || "Institution Banner",
        },
        gallery: galleryUrls.map(img => ({
          url: img.url,
          alt: img.alt || "",
        })),
        university: otherInstitutionData?.university?._id,
        country: otherInstitutionData?.country?.name,
        state: otherInstitutionData?.state,
        city: otherInstitutionData?.city,
        type: otherInstitutionData?.type?.name?.toLowerCase(),
        category: otherInstitutionData?.category?.name.toLowerCase(),
        isVerfied:
          otherInstitutionData?.isVerified === "Approve" ? true : false,
        verifiedStatus: otherInstitutionData?.verifiedStatus?.code || "pending",
        verifiedReason: otherInstitutionData?.verifiedReason
          ? otherInstitutionData?.verifiedReason
          : "",
        aiuAffiliation:
          otherInstitutionData?.aiuAffiliation?.name === "Yes" ? true : false,
        ugcApproval:
          otherInstitutionData?.ugcApproval?.name === "Yes" ? true : false,
        pixwikShow:
          otherInstitutionData?.pixwikShow?.name === "Yes" ? true : false,
        topPick: otherInstitutionData?.topPick?.name === "Yes" ? true : false,
        institutionId: institutionData?._id,
        cutoffs: otherInstitutionData?.cutoffs || [],
        reviews: otherInstitutionData?.reviews || [],
        qsRanking: otherInstitutionData?.qsRanking,
        beddedHospital: otherInstitutionData?.beddedHospital,
        yearlyIntake: otherInstitutionData?.yearlyIntake,
        departments: Array.isArray(otherInstitutionData?.departments)
          ? otherInstitutionData.departments.join(", ")
          : otherInstitutionData?.departments || "",
      }

      console.log("Final update payload:", payload)
      console.log("Verified Status being sent:", payload.verifiedStatus)

      setLoading(true)

      ValidateInstitution.validate(payload, { abortEarly: false })
        .then(() => {
          const config = {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          }

          InstituteApi.updateInstitution(payload, config)
            .then(response => {
              console.log("Update response:", response.data)
              if (response.data.status) {
                setLoading(false)
                setTimeout(() => {
                  navigate("/institutionlist")
                }, 1000)
                toast.current.show({
                  severity: "success",
                  summary: "Success",
                  detail: response.data.message,
                  life: 3000,
                })
              }
            })
            .catch(error => {
              console.error("Update error:", error.response || error)
              setLoading(false)
              toast.current.show({
                severity: "error",
                summary: "Error",
                detail: error.response?.data?.message || "Update failed",
                life: 3000,
              })
            })
        })
        .catch(err => {
          console.error("Validation error:", err)
          setLoading(false)

          const validationErrors = {}
          err.inner.forEach(error => {
            validationErrors[error.path] = error.message
          })
          setErrors(validationErrors)
        })
    } catch (error) {
      console.error("Unexpected error in updateUniversity:", error)
      setLoading(false)
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "An unexpected error occurred",
        life: 3000,
      })
    }
  }

  return (
    <div className="edit-institution">
      <Toast ref={toast} />
      <Row>
        <Col xs="12">
          <div className="university-list-header d-flex  align-items-center justify-content-between">
            <CustomBreadCrumb
              data={breadcrumbItems}
              pageTitle="Edit Institution"
            />
          </div>

          <Card className="mt-4 ">
            <CardBody>
              <div className="institution-edit-form ">
                <div className="institution-edit-inp">
                  <label htmlFor="university">University</label>

                  <div className="inp-err">
                    <Dropdown
                      value={updatedInstitutionData.university}
                      onChange={e => {
                        handleInstitutionDataChange("university", e.value)
                      }}
                      options={universityData}
                      optionLabel="universityName"
                      placeholder="Select University"
                      filter
                    />
                    {errors.university && (
                      <small className="error">{errors.university}</small>
                    )}
                  </div>
                </div>
                <div className="institution-edit-inp">
                  <label htmlFor="institutionName">Institution Name</label>
                  <div className="inp-err">
                    <InputText
                      id="institutionName"
                      value={updatedInstitutionData.institutionName}
                      onChange={e =>
                        handleInstitutionDataChange(
                          "institutionName",
                          e.target.value,
                        )
                      }
                      placeholder="Enter Institution Name"
                    />
                    {errors.institutionName && (
                      <small className="error">{errors.institutionName}</small>
                    )}
                  </div>
                </div>
                <div className="institution-edit-inp">
                  <label htmlFor="displayName">Display Name</label>

                  <div className="inp-err">
                    <InputText
                      id="displayName"
                      value={updatedInstitutionData.displayName}
                      onChange={e =>
                        handleInstitutionDataChange(
                          "displayName",
                          e.target.value,
                        )
                      }
                      placeholder="Enter Display Name"
                    />
                    {errors.displayName && (
                      <small className="error">{errors.displayName}</small>
                    )}
                  </div>
                </div>
                <div className="institution-edit-inp">
                  <label htmlFor="category">Category</label>
                  <div className="inp-err">
                    <Dropdown
                      value={updatedInstitutionData.category}
                      onChange={e =>
                        handleInstitutionDataChange("category", e.value)
                      }
                      options={categoryOptions}
                      optionLabel="name"
                      placeholder="Select Category"
                      filter
                    />
                    {errors.category && (
                      <small className="error">{errors.category}</small>
                    )}
                  </div>
                </div>
                <div className="institution-edit-inp">
                  <label htmlFor="type">Type</label>

                  <div className="inp-err">
                    <Dropdown
                      value={updatedInstitutionData.type}
                      onChange={e =>
                        handleInstitutionDataChange("type", e.value)
                      }
                      options={typeOptions}
                      optionLabel="name"
                      placeholder="Select Type"
                      filter
                    />
                    {errors.type && (
                      <small className="error">{errors.type}</small>
                    )}
                  </div>
                </div>
                <div className="institution-edit-inp">
                  <label htmlFor="yearEstablished"> Year Established</label>

                  <div className="inp-err">
                    <Calendar
                      id="yearEstablished"
                      value={
                        updatedInstitutionData.yearEstablished
                          ? new Date(updatedInstitutionData.yearEstablished, 0)
                          : null
                      }
                      onChange={e => {
                        const selectedYear = e.value
                          ? new Date(e.value).getFullYear()
                          : null
                        handleInstitutionDataChange(
                          "yearEstablished",
                          selectedYear,
                        )
                      }}
                      view="year"
                      dateFormat="yy"
                      placeholder="Select  Year Established"
                    />

                    {errors.yearEstablished && (
                      <small className="error">{errors.yearEstablished}</small>
                    )}
                  </div>
                </div>

                <div className="institution-edit-inp">
                  <label htmlFor="country">Country</label>
                  <div className="inp-err">
                    <Dropdown
                      id="country"
                      value={updatedInstitutionData.country}
                      onChange={e =>
                        handleInstitutionDataChange("country", e.value)
                      }
                      options={Country}
                      // itemTemplate={countryOptionTemplate}
                      optionLabel="name"
                      placeholder="Select Country"
                      filter
                      className="inp-field-box"
                    />

                    {errors.country && (
                      <small className="error">{errors.country}</small>
                    )}
                  </div>
                </div>

                <div className="institution-edit-inp">
                  <label htmlFor="state">State</label>
                  <div className="inp-err">
                    <InputText
                      id="state"
                      value={updatedInstitutionData.state}
                      onChange={e =>
                        handleInstitutionDataChange("state", e.target.value)
                      }
                      placeholder="Enter State"
                    />
                    {errors.state && (
                      <small className="error">{errors.state}</small>
                    )}
                  </div>
                </div>

                <div className="institution-edit-inp">
                  <label htmlFor="username">City</label>
                  <div className="inp-err">
                    <InputText
                      id="city"
                      placeholder="Enter City"
                      value={updatedInstitutionData.city}
                      onChange={e =>
                        handleInstitutionDataChange("city", e.target.value)
                      }
                    />
                    {errors.city && (
                      <small className="error">{errors.city}</small>
                    )}
                  </div>
                </div>

                <div className="institution-edit-inp">
                  <label htmlFor="pinCode"> Pin code</label>
                  <div className="inp-err">
                    <InputNumber
                      id="pinCode"
                      value={updatedInstitutionData.pinCode}
                      onChange={e =>
                        handleInstitutionDataChange("pinCode", e.value)
                      }
                      useGrouping={false}
                      placeholder="Enter Pin Code"
                    />
                    {errors.pinCode && (
                      <small className="error">{errors.pinCode}</small>
                    )}
                  </div>
                </div>

                <div className="institution-edit-inp">
                  <label htmlFor="address">Address</label>
                  <div className="inp-err">
                    <InputText
                      id="address"
                      value={updatedInstitutionData.address}
                      onChange={e =>
                        handleInstitutionDataChange("address", e.target.value)
                      }
                      placeholder="Enter Address"
                    />
                    {errors.address && (
                      <small className="error">{errors.address}</small>
                    )}
                  </div>
                </div>
                {/* <div className="institution-edit-inp">
                  <label htmlFor="phoneNumber">Phone</label>

                  <div className="inp-err">
                    <div className="p-inputgroup  phone-number ">
                      <Dropdown
                        id="phone"
                        value={updatedInstitutionData.country}
                        // onChange={e =>
                        // }
                        options={Country}
                        optionLabel="dialCode"
                        placeholder="+XX"
                        filter
                      />
                      <InputNumber
                        id="phoneNumber"
                        value={updatedInstitutionData.phone}
                        onChange={e =>
                          handleInstitutionDataChange("phone", e.value)
                        }
                        useGrouping={false}
                        placeholder="Enter Phone Number"
                      />
                    </div>
                    {errors.phone && (
                      <small className="error">{errors.phone}</small>
                    )}
                  </div>
                </div> */}
                <div className="institution-edit-inp">
                  <label htmlFor="email">Email</label>
                  <div className="inp-err">
                    <InputText
                      id="email"
                      value={updatedInstitutionData.email}
                      onChange={e =>
                        handleInstitutionDataChange("email", e.target.value)
                      }
                      placeholder="Enter Email"
                    />
                    {errors.email && (
                      <small className="error">{errors.email}</small>
                    )}
                  </div>
                </div>
                <div className="institution-edit-inp">
                  <label htmlFor="officialWebsite">Official Website</label>

                  <div className="inp-err">
                    <InputText
                      id="officialWebsite"
                      value={updatedInstitutionData.officialWebsite}
                      onChange={e =>
                        handleInstitutionDataChange(
                          "officialWebsite",
                          e.target.value,
                        )
                      }
                      placeholder="Enter Official Website"
                    />
                    {errors.officialWebsite && (
                      <small className="error">{errors.officialWebsite}</small>
                    )}
                  </div>
                </div>
                <div className="institution-edit-inp">
                  <label htmlFor="campusSize" className="label">
                    Campus Size
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="campusSize"
                      value={updatedInstitutionData.campusSize}
                      onChange={e =>
                        handleInstitutionDataChange(
                          "campusSize",
                          e.target.value,
                        )
                      }
                      placeholder="Enter CampusSize"
                      className="inp-field-box"
                    />
                    {errors.campusSize && (
                      <small className="error">{errors.campusSize}</small>
                    )}
                  </div>
                </div>

                <div className="institution-edit-inp">
                  <label htmlFor="noOfStudents" className="label">
                    No Of Students
                  </label>
                  <div className="inp-err">
                    <InputNumber
                      id="noOfStudents"
                      value={updatedInstitutionData.noOfStudents}
                      onChange={e =>
                        handleInstitutionDataChange("noOfStudents", e.value)
                      }
                      placeholder="Enter No Of Students"
                      className="inp-field-box"
                    />
                    {errors.noOfStudents && (
                      <small className="error">{errors.noOfStudents}</small>
                    )}
                  </div>
                </div>

                <div className="institution-edit-inp">
                  <label htmlFor="noOfDepartments" className="label">
                    No Of Departments
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="noOfDepartments"
                      value={updatedInstitutionData.noOfDepartments}
                      onChange={e =>
                        handleInstitutionDataChange(
                          "noOfDepartments",
                          e.target.value,
                        )
                      }
                      placeholder="Enter No Of Departments"
                      className="inp-field-box"
                    />
                    {errors.noOfDepartments && (
                      <small className="error">{errors.noOfDepartments}</small>
                    )}
                  </div>
                </div>
                <div className="institution-edit-inp">
                  <label htmlFor="noOfCourses" className="label">
                    No Of Courses
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="noOfCourses"
                      value={updatedInstitutionData.noOfCourses}
                      onChange={e =>
                        handleInstitutionDataChange(
                          "noOfCourses",
                          e.target.value,
                        )
                      }
                      placeholder="Enter No Of Courses"
                      className="inp-field-box"
                    />
                    {errors.noOfCourses && (
                      <small className="error">{errors.noOfCourses}</small>
                    )}
                  </div>
                </div>
                <div className="institution-edit-inp">
                  <label htmlFor="totalFaculty" className="label">
                    Total Faculty
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="totalFaculty"
                      value={updatedInstitutionData.totalFaculty}
                      onChange={e =>
                        handleInstitutionDataChange(
                          "totalFaculty",
                          e.target.value,
                        )
                      }
                      placeholder="Enter Total Faculty"
                      className="inp-field-box"
                    />
                    {errors.totalFaculty && (
                      <small className="error">{errors.totalFaculty}</small>
                    )}
                  </div>
                </div>
                <div className="institution-edit-inp">
                  <label htmlFor="nirfRanking" className="label">
                    NIRF Ranking
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="nirfRanking"
                      value={updatedInstitutionData.nirfRanking}
                      onChange={e =>
                        handleInstitutionDataChange(
                          "nirfRanking",
                          e.target.value,
                        )
                      }
                      placeholder="Enter NIRF Ranking"
                      className="inp-field-box"
                    />
                    {errors.nirfRanking && (
                      <small className="error">{errors.nirfRanking}</small>
                    )}
                  </div>
                </div>

                <div className="institution-edit-inp">
                  <label htmlFor="indiaToday2023Ranking" className="label">
                    India Today 2023 Ranking
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="indiaToday2023Ranking"
                      value={updatedInstitutionData.indiaToday2023Ranking}
                      onChange={e =>
                        handleInstitutionDataChange(
                          "indiaToday2023Ranking",
                          e.target.value,
                        )
                      }
                      placeholder="Enter India Today 2023 Ranking"
                      className="inp-field-box"
                    />
                    {errors.indiaToday2023Ranking && (
                      <small className="error">
                        {errors.indiaToday2023Ranking}
                      </small>
                    )}
                  </div>
                </div>
                <div className="institution-edit-inp">
                  <label htmlFor="timesRanking2024" className="label">
                    Times Ranking 2024
                  </label>
                  <div className="inp-err">
                    <InputNumber
                      id="timesRanking2024"
                      value={updatedInstitutionData.timesRanking2024}
                      onChange={e =>
                        handleInstitutionDataChange("timesRanking2024", e.value)
                      }
                      placeholder="Enter Times Ranking 2024"
                      className="inp-field-box"
                    />
                    {errors.timesRanking2024 && (
                      <small className="error">{errors.timesRanking2024}</small>
                    )}
                  </div>
                </div>
                <div className="institution-edit-inp">
                  <label htmlFor="qsRanking" className="label">
                    QS Ranking
                  </label>
                  <div className="inp-err">
                    <InputNumber
                      id="qsRanking"
                      value={updatedInstitutionData.qsRanking}
                      onChange={e =>
                        handleInstitutionDataChange("qsRanking", e.value)
                      }
                      placeholder="Enter QS Ranking"
                      className="inp-field-box"
                    />
                    {errors.qsRanking && (
                      <small className="error">{errors.qsRanking}</small>
                    )}
                  </div>
                </div>
                <div className="institution-edit-inp">
                  <label htmlFor="ugcApproval" className="label">
                    UGC Approval
                  </label>
                  <div className="inp-err ">
                    <Dropdown
                      value={updatedInstitutionData.ugcApproval}
                      onChange={e =>
                        handleInstitutionDataChange("ugcApproval", e.value)
                      }
                      options={approvalOptions}
                      optionLabel="name"
                      placeholder="Select UGC Affiliation"
                      className="inp-field-box"
                    />
                    {errors.ugcApproval && (
                      <small className="error">{errors.ugcApproval}</small>
                    )}
                  </div>
                </div>
                <div className="institution-edit-inp">
                  <label htmlFor="aiuAffiliation" className="label">
                    AIU Affiliation
                  </label>
                  <div className="inp-err">
                    <Dropdown
                      value={updatedInstitutionData.aiuAffiliation}
                      onChange={e =>
                        handleInstitutionDataChange("aiuAffiliation", e.value)
                      }
                      options={approvalOptions}
                      optionLabel="name"
                      placeholder="Select AIU Affiliation"
                      className="inp-field-box"
                    />
                    {errors.aiuAffiliation && (
                      <small className="error">{errors.aiuAffiliation}</small>
                    )}
                  </div>
                </div>

                <div className="institution-edit-inp">
                  <label htmlFor="pixwikShow" className="label">
                    Pixwik Show
                  </label>
                  <div className="inp-err">
                    <Dropdown
                      value={updatedInstitutionData.pixwikShow}
                      onChange={e =>
                        handleInstitutionDataChange("pixwikShow", e.value)
                      }
                      options={approvalOptions}
                      optionLabel="name"
                      placeholder="Select Pixwik Show"
                      className="inp-field-box"
                    />
                  </div>
                </div>
                <div className="institution-edit-inp">
                  <label htmlFor="highlights" className="label">
                    Highlights
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="highlights"
                      value={updatedInstitutionData.highlights}
                      onChange={e =>
                        handleInstitutionDataChange(
                          "highlights",
                          e.target.value,
                        )
                      }
                      placeholder="Enter Highlights"
                      className="inp-field-box"
                    />
                    {errors.highlights && (
                      <small className="error">{errors.highlights}</small>
                    )}
                  </div>
                </div>
                <div className="institution-edit-inp">
                  <label htmlFor="aboutContent" className="label">
                    About Content
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="aboutContent"
                      value={updatedInstitutionData.aboutContent}
                      onChange={e =>
                        handleInstitutionDataChange(
                          "aboutContent",
                          e.target.value,
                        )
                      }
                      placeholder="Enter About Content"
                      className="inp-field-box"
                    />
                    {errors.aboutContent && (
                      <small className="error">{errors.highlights}</small>
                    )}
                  </div>
                </div>

                <div className="institution-edit-inp">
                  <label htmlFor="description" className="label">
                    Description
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="description"
                      value={updatedInstitutionData.description}
                      onChange={e =>
                        handleInstitutionDataChange(
                          "description",
                          e.target.value,
                        )
                      }
                      placeholder="Enter Description"
                      className="inp-field-box"
                    />
                    {errors.description && (
                      <small className="error">{errors.description}</small>
                    )}
                  </div>
                </div>

                <div className="institution-edit-inp">
                  <label htmlFor="beddedHospital" className="label">
                    Bedded Hospital
                  </label>
                  <div className="inp-err">
                    <InputNumber
                      id="beddedHospital"
                      value={updatedInstitutionData.beddedHospital}
                      onChange={e =>
                        handleInstitutionDataChange("beddedHospital", e.value)
                      }
                      placeholder="Enter Bedded Hospital Count"
                      className="inp-field-box"
                    />
                    {errors.beddedHospital && (
                      <small className="error">{errors.beddedHospital}</small>
                    )}
                  </div>
                </div>

                <div className="institution-edit-inp">
                  <label htmlFor="yearlyIntake" className="label">
                    Yearly Intake
                  </label>
                  <div className="inp-err">
                    <InputNumber
                      id="yearlyIntake"
                      value={updatedInstitutionData.yearlyIntake}
                      onChange={e =>
                        handleInstitutionDataChange("yearlyIntake", e.value)
                      }
                      placeholder="Enter Yearly Intake"
                      className="inp-field-box"
                    />
                    {errors.yearlyIntake && (
                      <small className="error">{errors.yearlyIntake}</small>
                    )}
                  </div>
                </div>

                <div className="institution-edit-inp">
                  <label htmlFor="neetYear" className="label">
                    NEET Year
                  </label>
                  <div className="inp-err">
                    <Calendar
                      id="neetYear"
                      value={
                        updatedInstitutionData.neetYear
                          ? new Date(updatedInstitutionData.neetYear, 0)
                          : null
                      }
                      onChange={e => {
                        const selectedYear = e.value
                          ? new Date(e.value).getFullYear()
                          : null
                        handleInstitutionDataChange(
                          "neetYear",
                          selectedYear,
                        )
                      }}
                      view="year"
                      dateFormat="yy"
                      placeholder="Select NEET Year"
                      className="inp-field-box"
                    />
                    {errors.neetYear && (
                      <small className="error">{errors.neetYear}</small>
                    )}
                  </div>
                </div>

                <div className="institution-edit-inp">
                  <label htmlFor="fees" className="label">
                    Fees
                  </label>
                  <div className="inp-err">
                    <InputNumber
                      id="fees"
                      value={updatedInstitutionData.fees}
                      onChange={e =>
                        handleInstitutionDataChange("fees", e.value)
                      }
                      placeholder="Enter Fees"
                      className="inp-field-box"
                    />
                    {errors.fees && (
                      <small className="error">{errors.fees}</small>
                    )}
                  </div>
                </div>

                <div className="institution-edit-inp">
                  <label htmlFor="nriFees" className="label">
                    NRI Fees
                  </label>
                  <div className="inp-err">
                    <InputNumber
                      id="nriFees"
                      value={updatedInstitutionData.nriFees}
                      onChange={e =>
                        handleInstitutionDataChange("nriFees", e.value)
                      }
                      placeholder="Enter NRI Fees"
                      className="inp-field-box"
                    />
                    {errors.nriFees && (
                      <small className="error">{errors.nriFees}</small>
                    )}
                  </div>
                </div>

                <div className="institution-edit-inp">
                  <label htmlFor="hostelFees" className="label">
                    Hostel Fees
                  </label>
                  <div className="inp-err">
                    <InputNumber
                      id="hostelFees"
                      value={updatedInstitutionData.hostelFees}
                      onChange={e =>
                        handleInstitutionDataChange("hostelFees", e.value)
                      }
                      placeholder="Enter Hostel Fees"
                      className="inp-field-box"
                    />
                    {errors.hostelFees && (
                      <small className="error">{errors.hostelFees}</small>
                    )}
                  </div>
                </div>

                <div className="institution-edit-inp">
                  <label htmlFor="priceRange" className="label">
                    Price Range
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="priceRange"
                      value={updatedInstitutionData.priceRange}
                      onChange={e =>
                        handleInstitutionDataChange("priceRange", e.target.value)
                      }
                      placeholder="Enter Price Range"
                      className="inp-field-box"
                    />
                    {errors.priceRange && (
                      <small className="error">{errors.priceRange}</small>
                    )}
                  </div>
                </div>

                <div className="institution-edit-inp">
                  <label htmlFor="topPick" className="label">
                    Top Pick
                  </label>
                  <div className="inp-err">
                    <Dropdown
                      id="topPick"
                      value={updatedInstitutionData.topPick}
                      onChange={e =>
                        handleInstitutionDataChange("topPick", e.value)
                      }
                      options={approvalOptions}
                      optionLabel="name"
                      placeholder="Select Top Pick"
                      className="inp-field-box"
                    />
                    {errors.topPick && (
                      <small className="error">{errors.topPick}</small>
                    )}
                  </div>
                </div>

                {userData?.role === "manager" && (
                  <>
                    <div className="institution-edit-inp">
                      <label htmlFor="verifiedStatus" className="label">
                        Verification
                      </label>
                      <div className="inp-err">
                        <Dropdown
                          id="verifiedStatus"
                          value={updatedInstitutionData.verifiedStatus}
                          onChange={e =>
                            handleInstitutionDataChange(
                              "verifiedStatus",
                              e.value,
                            )
                          }
                          options={verficationOption}
                          optionLabel="name"
                          placeholder="Select Verification Status"
                          className="inp-field-box"
                        />
                        {errors.verifiedStatus && (
                          <small className="error">
                            {errors.verifiedStatus}
                          </small>
                        )}
                      </div>
                    </div>

                    <div className="institution-edit-inp">
                      <label htmlFor="verifiedReason" className="label">
                        Verification Reason
                      </label>
                      <div className="inp-err">
                        <InputText
                          id="verifiedReason"
                          value={updatedInstitutionData.verifiedReason}
                          onChange={e =>
                            handleInstitutionDataChange(
                              "verifiedReason",
                              e.target.value,
                            )
                          }
                          placeholder="Enter Verification Reason"
                          className="inp-field-box"
                        />
                        {errors.verifiedReason && (
                          <small className="error">
                            {errors.verifiedReason}
                          </small>
                        )}
                      </div>
                    </div>

                    <div className="institution-edit-inp">
                      <label htmlFor="brochure" className="label">
                        Brochure
                      </label>
                      <div className="inp-err">
                        {brochureUrl && (
                          <div className="mb-2 position-relative">
                            <img
                              src={brochureUrl}
                              alt="Institution Brochure"
                              style={{
                                width: "100px",
                                height: "100px",
                                objectFit: "cover",
                                borderRadius: "4px",
                              }}
                            />
                            <Button
                              type="button"
                              color="danger"
                              size="sm"
                              className="position-absolute top-0 end-0 p-1"
                              onClick={handleBrochureDelete}
                            >
                              ×
                            </Button>
                          </div>
                        )}
                        {brochureFile && (
                          <div className="mb-2">
                            <small>Selected file: {brochureFile.name}</small>
                          </div>
                        )}
                        <div className="d-flex align-items-center gap-2">
                          <input
                            type="file"
                            name="brochure"
                            id="brochure"
                            accept="image/*,application/pdf"
                            onChange={handleBrochureChange}
                          />
                          {brochureFile && !isUploading && (
                            <Button
                              type="button"
                              color="primary"
                              size="sm"
                              className="waves-effect waves-light"
                              onClick={uploadBrochure}
                            >
                              Upload
                            </Button>
                          )}
                        </div>
                        {isUploading && (
                          <small className="d-block mt-1">
                            <Spinner size="sm" /> Uploading brochure...
                          </small>
                        )}
                        {brochureUrl && (
                          <small className="d-block mt-1 text-success">
                            Brochure uploaded successfully!
                          </small>
                        )}
                      </div>
                    </div>
                  </>
                )}

                <div className="institution-edit-inp">
                  <label htmlFor="logo" className="label">
                    Logo
                  </label>
                  <div className="inp-err">
                    {logoUrl && (
                      <div className="mb-2 position-relative">
                        <img
                          src={logoUrl}
                          alt={
                            updatedInstitutionData.logo?.alt ||
                            "Institution Logo"
                          }
                          style={{
                            width: "100px",
                            height: "auto",
                            objectFit: "contain",
                            border: "1px solid #ddd",
                            borderRadius: "4px",
                            padding: "2px",
                          }}
                        />
                        <Button
                          type="button"
                          color="danger"
                          size="sm"
                          className="position-absolute top-0 end-0"
                          style={{ margin: "2px" }}
                          onClick={handleLogoDelete}
                        >
                          ×
                        </Button>
                      </div>
                    )}
                    {logoFile && (
                      <div className="mb-2">
                        <small>Selected file: {logoFile.name}</small>
                      </div>
                    )}
                    <div className="d-flex align-items-center gap-2">
                      <input
                        type="file"
                        name="logo"
                        id="logo"
                        accept="image/*"
                        onChange={handleLogoChange}
                      />
                      {logoFile && !isUploading && (
                        <Button
                          type="button"
                          color="primary"
                          size="sm"
                          className="waves-effect waves-light"
                          onClick={() => uploadLogo()}
                        >
                          Upload
                        </Button>
                      )}
                    </div>
                    {isUploading && (
                      <small className="d-block mt-1">
                        <Spinner size="sm" /> Uploading logo...
                      </small>
                    )}
                    {logoUrl && (
                      <>
                        <small className="d-block mt-1 text-success">
                          Logo uploaded successfully!
                        </small>
                        <div className="mb-2">
                          <label htmlFor="logoAltText">Logo Alt Text</label>
                          <InputText
                            id="logoAltText"
                            name="logoAltText"
                            className="w-100"
                            placeholder="Enter descriptive text for the logo"
                            value={updatedInstitutionData.logo?.alt || ""}
                            onChange={e => {
                              handleInstitutionDataChange("logo", {
                                url: logoUrl,
                                alt: e.target.value,
                              })
                            }}
                          />
                        </div>
                      </>
                    )}
                  </div>
                </div>

                <div className="institution-edit-inp">
                  <label htmlFor="banner" className="label">
                    Banner Image
                  </label>
                  <div className="inp-err">
                    {bannerUrl && (
                      <div className="mb-2 position-relative">
                        <img
                          src={bannerUrl}
                          alt={
                            updatedInstitutionData.bannerImage?.alt ||
                            "Institution Banner"
                          }
                          style={{
                            width: "200px",
                            height: "auto",
                            objectFit: "contain",
                            border: "1px solid #ddd",
                            borderRadius: "4px",
                            padding: "2px",
                          }}
                        />
                        <Button
                          type="button"
                          color="danger"
                          size="sm"
                          className="position-absolute top-0 end-0"
                          style={{ margin: "2px" }}
                          onClick={handleBannerDelete}
                        >
                          ×
                        </Button>
                      </div>
                    )}
                    {bannerFile && (
                      <div className="mb-2">
                        <small>Selected file: {bannerFile.name}</small>
                      </div>
                    )}
                    <div className="d-flex align-items-center gap-2">
                      <input
                        type="file"
                        name="banner"
                        id="banner"
                        accept="image/*"
                        onChange={handleBannerChange}
                      />
                      {bannerFile && !isUploadingBanner && (
                        <Button
                          type="button"
                          color="primary"
                          size="sm"
                          className="waves-effect waves-light"
                          onClick={uploadBanner}
                        >
                          Upload Banner
                        </Button>
                      )}
                    </div>
                    {isUploadingBanner && (
                      <small className="d-block mt-1">
                        <Spinner size="sm" /> Uploading banner...
                      </small>
                    )}
                    {bannerUrl && (
                      <>
                        <small className="d-block mt-1 text-success">
                          Banner uploaded successfully!
                        </small>
                        <div className="mb-2">
                          <label htmlFor="bannerAltText">Banner Alt Text</label>
                          <InputText
                            id="bannerAltText"
                            name="bannerAltText"
                            className="w-100"
                            placeholder="Enter descriptive text for the banner"
                            value={
                              updatedInstitutionData.bannerImage?.alt || ""
                            }
                            onChange={e => {
                              handleInstitutionDataChange("bannerImage", {
                                url: bannerUrl,
                                alt: e.target.value,
                              })
                            }}
                          />
                        </div>
                      </>
                    )}
                  </div>
                </div>

                <div className="institution-edit-inp">
                  <label htmlFor="gallery" className="label">
                    Gallery Images
                  </label>
                  <div className="inp-err">
                    {(galleryUrls || []).length > 0 && (
                      <div className="mb-3 d-flex flex-wrap gap-2">
                        {(galleryUrls || []).map((url, index) => (
                          <div key={index} className="position-relative">
                            <img
                              src={url.url}
                              alt={
                                updatedInstitutionData.gallery[index]?.alt ||
                                `Institution Gallery Image ${index + 1}`
                              }
                              style={{
                                width: "100px",
                                height: "100px",
                                objectFit: "cover",
                                borderRadius: "4px",
                              }}
                            />
                            <Button
                              type="button"
                              color="danger"
                              size="sm"
                              className="position-absolute top-0 end-0 p-1"
                              onClick={() => removeGalleryImage(index)}
                            >
                              ×
                            </Button>
                            <InputText
                              placeholder="Enter alt text for this image"
                              value={galleryAltTexts[index] || ""}
                              onChange={e =>
                                handleGalleryAltTextChange(
                                  index,
                                  e.target.value,
                                )
                              }
                              className="w-100 mt-1"
                            />
                          </div>
                        ))}
                      </div>
                    )}
                    <div className="d-flex align-items-center gap-2">
                      <input
                        type="file"
                        name="gallery"
                        id="gallery"
                        accept="image/*"
                        multiple
                        onChange={handleGalleryChange}
                      />
                      {galleryFiles.length > 0 && !isUploadingGallery && (
                        <Button
                          type="button"
                          color="primary"
                          size="sm"
                          className="waves-effect waves-light"
                          onClick={uploadGalleryImages}
                        >
                          Upload Gallery
                        </Button>
                      )}
                    </div>
                    {galleryFiles.length > 0 && (
                      <div className="mt-2">
                        <small>Selected files: {galleryFiles.length}</small>
                      </div>
                    )}
                  </div>
                </div>

                <div className="reviews-section mt-4">
                  <h5 className="border-bottom pb-2 mb-3">Reviews</h5>
                  {(updatedInstitutionData?.reviews || []).length > 0 ? (
                    <Row className="g-4">
                      {updatedInstitutionData.reviews.map((review, index) => (
                        <Col md="6" lg="4" key={index}>
                          <Card className="review-card h-100 p-3">
                            <div className="d-flex justify-content-end mb-2">
                              <Button
                                type="button"
                                color="danger"
                                size="sm"
                                onClick={() => {
                                  const newReviews = [
                                    ...updatedInstitutionData.reviews,
                                  ]
                                  newReviews.splice(index, 1)
                                  handleInstitutionDataChange(
                                    "reviews",
                                    newReviews,
                                  )
                                }}
                              >
                                ×
                              </Button>
                            </div>
                            <div className="review-header d-flex align-items-center gap-3 mb-3">
                              <Avatar
                                label={
                                  review.name?.charAt(0)?.toUpperCase() || "U"
                                }
                                size="large"
                                shape="circle"
                                style={{
                                  backgroundColor:
                                    "#" +
                                    Math.floor(
                                      Math.random() * 16777215,
                                    ).toString(16),
                                  color: "#ffffff",
                                  padding: "10px",
                                }}
                              />
                              <div>
                                <h6 className="mb-1">{review.name}</h6>
                                <small className="text-muted">
                                  {review.createdAt
                                    ? formatDistanceToNow(
                                        new Date(review.createdAt),
                                        { addSuffix: true },
                                      )
                                    : "Recently added"}
                                </small>
                              </div>
                            </div>
                            <div className="review-content">
                              <p className="mb-0" style={{ lineHeight: "1.6" }}>
                                {review.review}
                              </p>
                            </div>
                          </Card>
                        </Col>
                      ))}
                    </Row>
                  ) : (
                    <div className="text-center py-5">
                      <p>No reviews available</p>
                    </div>
                  )}
                </div>
              </div>
              <div className="save-cancel-btn mt-4 d-flex align-items-center justify-content-end gap-3">
                <Button
                  type="button"
                  outline
                  color="danger"
                  className="waves-effect waves-light"
                  onClick={() => {
                    navigate(-1)
                  }}
                >
                  Cancel
                </Button>
                <Button
                  type="button"
                  color="secondary"
                  className="waves-effect waves-light"
                  disabled={loading}
                  onClick={() => {
                    updateUniversity()
                  }}
                >
                  {loading ? <Spinner size="sm" /> : "Update"}
                </Button>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  )
}

export default EditInstitution
